import React from 'react';

const AlertModal = ({ visible, title, content, onClose }) => {
  if (!visible) return null;

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999
  };

  const modalStyle = {
    background: 'white',
    borderRadius: '8px',
    width: '400px',
    maxWidth: '90%',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
    padding: '20px'
  };

  const headerStyle = {
    marginBottom: '10px'
  };

  const bodyStyle = {
    fontSize: '1rem'
  };

  const footerStyle = {
    marginTop: '20px',
    textAlign: 'right'
  };

  const buttonStyle = {
    backgroundColor: '#F6931E',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '5px',
    cursor: 'pointer'
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h2>{title}</h2>
        </div>
        <div style={bodyStyle}>
          <p>{content}</p>
        </div>
        <div style={footerStyle}>
          <button onClick={onClose} style={buttonStyle}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
